import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      banner: document.querySelector('.blog-banner'),
      header: document.querySelector('header')
    };
    this.setupBannerTop();
  }

  addListeners() {
    window.addEventListener('resize', this.setupBannerTop.bind(this));
    if(this.dom.header) {
      new ResizeObserver(this.setupBannerTop.bind(this)).observe(this.dom.header);
    }
  }

  setupBannerTop() {
    if(this.dom.header) {
    const headerHeight = this.dom.header.offsetHeight;
    this.dom.banner.style.top = `${headerHeight}px`;
    } else {
      this.dom.banner.style.top = '110px';
    }
  }
  
}

export default Module;
